import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { setPasswordVisibility } from "../redux/actions/authActions";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { validateForm } from "../../utils/validation";
import * as LocalStorage from "../../utils/localStorage";
import styles from "./loginStyles.module.css";
import Header from "../header";

const Login = () => {
  const actionDispatch = useDispatch();
  const { passwordVisible } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const [values, setValues] = useState({
    email: "",
    password: "",
  });
  const onInputChange = (e) => {
    const { name, value } = e.target;
    setValues((state) => ({ ...state, [name]: value }));
  };
  const onLogin = (event) => {
    event.preventDefault();
    const { isValid, errors } = validateForm(values);
    if (isValid) {
      navigate("/dashboard", {
        replace: true,
      });
      LocalStorage.setLSValue("user", true);
    }
    else{
      if (errors.email || errors.password) {
        alert(errors.email || errors.password);
      }
    }
  };
  const showPassword = () => {
    passwordVisible
      ? actionDispatch(setPasswordVisibility(false))
      : actionDispatch(setPasswordVisibility(true));
  };
  return (
    <div className={styles.login}>
      <Header />
      <main className={styles.mainDiv}>
        <form className={styles.loginForm} onSubmit={(e) => onLogin(e)}>
          <h1 className={styles.formHeading}>Welcome to Dashboard, Login</h1>
          <label htmlFor={styles.userEmail} className={styles.emailLabel}>
            <input
              id={styles.userEmail}
              name="email"
              type="text"
              className={styles.loginInputs}
              placeholder="Email"
              autoFocus
              onChange={onInputChange}
            ></input>
            <div className={styles.inputBorderDivEmail}></div>
          </label>
          <label htmlFor={styles.userPassword} className={styles.passwordLabel}>
            <input
              id={styles.userPassword}
              name="password"
              className={styles.loginInputs}
              type={passwordVisible ? "text" : "password"}
              placeholder="password"
              onChange={onInputChange}
              autoComplete="off"
            ></input>
            <div className={styles.inputBorderDivPassword}></div>
            <span className={styles.passwordEye} onClick={showPassword}>
              {passwordVisible ? <FaRegEyeSlash /> : <FaRegEye />}
            </span>
          </label>
          <button id={styles.loginSubmit} type="submit">
            Login
          </button>
        </form>
      </main>
    </div>
  );
};

export default Login;
